import { useOrderStore } from '@blocks/stores/order';
import getStoredOrderValues from '@blocks/utils/getStoredOrderValues';

import { getDefaultDate } from '../../utils';

/**
 * @param {FormApi} form
 */
export function createStorageDecorator(form) {
  const ignoreFields = [
    'showPassword',
    'showGdpr',
    'showWriter',
    'password',
    // 'policy_agree',
    // 'marketing_agree',
    'isSatellite',
    'domain',
    'showTitle',
  ];

  const defaultDate = getDefaultDate();
  const storedValues = getStoredOrderValues();
  const storedDeadline = storedValues.deadline_datetime || 0;
  const { initialValues } = form.getState();

  form.initialize({
    ...initialValues,
    ...storedValues,
    deadline_datetime: storedDeadline > defaultDate ? storedValues.deadline_datetime : defaultDate,
  });

  return form.subscribe(
    ({ values, modified }) => {
      const storageValues = useOrderStore.getState().order;

      const nextValues = Object.keys(modified).reduce((acc, field) => {
        if (!ignoreFields.includes(field)) {
          acc[field] = values[field];
        }

        return acc;
      }, storageValues);

      useOrderStore.getState().setOrderAction(nextValues);
    },
    {
      values: true,
      modified: true,
    },
  );
}
